import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import Route from 'react-router/Route';
import { branch, compose, lifecycle, renderComponent, withProps } from "recompose";
import { bindActionCreators } from 'redux';
import { routes } from '../../constants';
import { adminActions } from '../../state/modules/admin';
import { cpdCategorysActions } from '../../state/modules/areas-of-advice';
import { industryActions } from '../../state/modules/industry';
import { userActions } from '../../state/modules/user';
import PublisherUpdate from '../pages/admin-portal/publisher-portal/partials/publisherUpdate';
import { 
  AdminBusinessReport as businessReport,
  AdminContent as Content,
  AdminContentRating as ContentRating,
  AdminContentCompletion as ContentCompletion,
  AdminCpdAvailability as CpdAvailability,
  AdminCpdCategory as CpdCategory,
  AdminCpdCategoryAdd as CpdCategoryAdd,
  AdminCpdCategoryEdit as CpdCategoryEdit,
  AdminCpdPointPortal as CpdPointPortal,
  AdminIndustry as Industry,
  AdminIndustryAdd as IndustryAdd,
  AdminIndustryEdit as IndustryEdit,
  AdminPortal as Dashboard,
  AdminPublisher as Publisher,
  AdminQualificationType as QualificationType,
  AdminQualificationTypeEdit as QualificationTypeEdit,
  AdminTaskGroupDetails, AdminTaskPortal,
  AdminTestingPortal as TestingPortal,
  AdminUserEngagement as UserEngagement,
  AdminUserReport as UserReport,
  AdminUserSnapshotReport as UserSnapshotReport,
  AdminUserCpdProgressReport as UserCpdProgressReport,
  AdminEndOfYearReport as EndOfYearReport,
  Loading,
} from '../pages';
import { AdminNav } from '../partials';

const AdminPortal = ({
  withNavBar
}) => (
    <div className='clearfix content-body'>
      <Switch>
        <Route exact path={routes.adminPortal.dashboard} component={withNavBar(Dashboard)} />
        <Route exact path={routes.adminPortal.publisher} component={withNavBar(Publisher)} />
        <Route exact path={routes.adminPortal.publisherEdit(":publisherId")} component={withNavBar(PublisherUpdate)} />
        <Route exact path={routes.adminPortal.content} component={withNavBar(Content)} />
        <Route exact path={routes.adminPortal.contentRating} component={withNavBar(ContentRating)} />
        <Route exact path={routes.adminPortal.contentCompletion} component={withNavBar(ContentCompletion)} />
        <Route exact path={routes.adminPortal.industry} component={withNavBar(Industry)} />
        <Route exact path={routes.adminPortal.industryAdd} component={withNavBar(IndustryAdd)} />
        <Route exact path={routes.adminPortal.qualificationType} component={withNavBar(QualificationType)} />
        <Route exact path={routes.adminPortal.qualificationTypeEdit(':qualificationTypeId')} component={withNavBar(QualificationTypeEdit)} />
        <Route exact path={routes.adminPortal.qualificationTypeAdd} component={withNavBar(QualificationTypeEdit)} />
        <Route exact path={routes.adminPortal.cpdCategory} component={withNavBar(CpdCategory)} />
        <Route exact path={routes.adminPortal.industryEdit(':industryId')} component={withNavBar(IndustryEdit)} />
        <Route exact path={routes.adminPortal.cpdCategoryEdit(':cpdCategoryId')} component={withNavBar(CpdCategoryEdit)} />
        <Route exact path={routes.adminPortal.cpdCategoryAdd} component={withNavBar(CpdCategoryAdd)} />
        <Route exact path={routes.adminPortal.userReport(':user', ':yearsFromNow')} component={withNavBar(UserReport)} />
        <Route exact path={routes.adminPortal.userSnapshotReport(':user', ':snapshot')} component={withNavBar(UserSnapshotReport)} />
        <Route exact path={routes.adminPortal.businessReport(':business', ':yearsFromNow')} component={withNavBar(businessReport)} />
        <Route exact path={routes.adminPortal.testing} component={withNavBar(TestingPortal)} />
        <Route exact path={routes.adminPortal.cpdPoint} component={withNavBar(CpdPointPortal)} />
        <Route exact path={routes.adminPortal.cpdAvailability} component={withNavBar(CpdAvailability)} />
        <Route exact path={routes.adminPortal.adminTaskGroup} component={withNavBar(AdminTaskPortal)} />
        <Route exact path={routes.adminPortal.adminTaskGroupDetails(':adminTaskGroupId')} component={withNavBar(AdminTaskGroupDetails)} />
        <Route exact path={routes.adminPortal.userEngagement} component={withNavBar(UserEngagement)} />
        <Route exact path={routes.adminPortal.userCpdProgressReport} component={withNavBar(UserCpdProgressReport)} />
        <Route exact path={routes.adminPortal.endOfYearReport} component={withNavBar(EndOfYearReport)} />
      </Switch>
    </div>
  );

const mapStateToProps = (state) => ({
  isAuthenticated: state.session.isAuthenticated,
  isFetchingConfig: state.configuration.isFetching
});

const mapDispatchToProps = (dispatch) => ({
  getUser: bindActionCreators(userActions.user.getCurrent, dispatch),
  getAllCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch),
  getIndustries: bindActionCreators(industryActions.industries.get, dispatch),
  getIndustryCpdCategory: bindActionCreators(adminActions.admin.getIndustryCpdCategory, dispatch),
  getIndustriesWithCpdCategorys: bindActionCreators(industryActions.industries.industriesWithCpdCategorys, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ isAuthenticated }) => !isAuthenticated,
    renderComponent(() => (
      <Redirect to={routes.login} />
    ))
  ),
  branch(
    ({ isFetchingConfig }) => isFetchingConfig,
    renderComponent(Loading)
  ),
  lifecycle({
    componentDidMount() {
      this.props.getUser();
      this.props.getAllCpdCategorys();
      this.props.getIndustries();
      this.props.getIndustryCpdCategory();
      this.props.getIndustriesWithCpdCategorys();
    }
  }),
  withProps(() => ({
    withNavBar: (Component) => (props) => (
      <div className='clearfix content-body'>
        <AdminNav />
        <Component {...props} />
      </div>
    )
  })),
)(AdminPortal);



// WEBPACK FOOTER //
// ./src/containers/layouts/admin-portal.js